import { render, staticRenderFns } from "./headNew.vue?vue&type=template&id=6de225b4"
import script from "./headNew.vue?vue&type=script&lang=js"
export * from "./headNew.vue?vue&type=script&lang=js"
import style0 from "./headNew.vue?vue&type=style&index=0&id=6de225b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports